import { Equipment } from './../models2/maintenance/equipment';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { environment } from 'environments/environment';
import { HttpService, MessageService } from 'brainloper-ui';

@Injectable({
  providedIn: 'root'
})
export class EquipmentService {

  constructor(
    private message: MessageService,
    private http: HttpService,
  ) { }


}
